(function() {
  'use strict';

  let isotopeLoaded = false;
  let fancyboxLoaded = false;

  function loadIsotope(callback) {
    if (typeof Isotope !== 'undefined') {
      isotopeLoaded = true;
      if (callback) callback();
      return;
    }

    if (isotopeLoaded) {
      if (callback) callback();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/isotope-layout@3.0.6/dist/isotope.pkgd.min.js';
    script.onload = function() {
      isotopeLoaded = true;
      if (callback) callback();
    };
    script.onerror = function() {
      console.error('Failed to load Isotope library');
    };
    document.head.appendChild(script);
  }

  function loadFancybox(callback) {
    // Check if already loaded
    if (typeof window.Fancybox !== 'undefined' || typeof window.fancybox !== 'undefined' || typeof Fancybox !== 'undefined') {
      fancyboxLoaded = true;
      if (callback) callback();
      return;
    }

    if (fancyboxLoaded) {
      if (callback) callback();
      return;
    }

    // Check if CSS is already loaded
    const existingCSS = document.querySelector('link[href*="fancybox.css"]');
    if (!existingCSS) {
      const fancyboxCSS = document.createElement('link');
      fancyboxCSS.rel = 'stylesheet';
      fancyboxCSS.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
      document.head.appendChild(fancyboxCSS);
    }

    // Check if script is already loading
    const existingScript = document.querySelector('script[src*="fancybox"]');
    if (existingScript) {
      existingScript.addEventListener('load', function() {
        fancyboxLoaded = true;
        if (callback) callback();
      });
      return;
    }

    // Then load JS
    const fancyboxScript = document.createElement('script');
    fancyboxScript.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js';
    fancyboxScript.onload = function() {
      fancyboxLoaded = true;
      // Wait a bit for Fancybox to be fully available
      setTimeout(function() {
        // Debug: Check what's available
        console.log('Fancybox loaded. Available:', {
          windowFancybox: typeof window.Fancybox,
          windowFancyboxLower: typeof window.fancybox,
          globalFancybox: typeof Fancybox
        });
        if (callback) callback();
      }, 50);
    };
    fancyboxScript.onerror = function() {
      console.error('Failed to load Fancybox library');
    };
    document.head.appendChild(fancyboxScript);
  }

  function initializeGalleries() {
    const galleryContainers = document.querySelectorAll('.article-gallery__container');
    
    if (galleryContainers.length === 0) return;

    galleryContainers.forEach(function(container) {
      const galleryId = container.getAttribute('data-gallery-id');
      if (!galleryId) return;

      const galleryLinks = container.querySelectorAll('.article-gallery__link');
      if (galleryLinks.length === 0) return;

      // Store reference to container and links
      container._galleryLinks = galleryLinks;
      container._galleryId = galleryId;

      // Initialize Isotope first
      loadIsotope(function() {
        if (typeof Isotope === 'undefined') {
          console.error('Isotope not available');
          return;
        }

        // Initialize Isotope
        const iso = new Isotope(container, {
          itemSelector: '.article-gallery__item',
          layoutMode: 'masonry',
          masonry: {
            columnWidth: '.article-gallery__item',
            gutter: 16
          },
          percentPosition: false
        });

        container._isotope = iso;

        // Wait for images to load before layout
        const images = container.querySelectorAll('img');
        let loadedCount = 0;
        const totalImages = images.length;

        if (totalImages === 0) {
          iso.layout();
          return;
        }

        function checkAllLoaded() {
          loadedCount++;
          if (loadedCount === totalImages) {
            setTimeout(function() {
              iso.layout();
            }, 100);
          }
        }

        images.forEach(function(img) {
          if (img.complete && img.naturalHeight !== 0) {
            checkAllLoaded();
          } else {
            img.addEventListener('load', checkAllLoaded);
            img.addEventListener('error', checkAllLoaded);
          }
        });

        // Layout on window resize
        let resizeTimer;
        const resizeHandler = function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            if (container._isotope) {
              container._isotope.layout();
            }
          }, 250);
        };
        window.addEventListener('resize', resizeHandler);
        container._resizeHandler = resizeHandler;
      });

      // Initialize Fancybox
      loadFancybox(function() {
        // Check for Fancybox in different possible locations
        let FancyboxLib = window.Fancybox || window.fancybox || (typeof Fancybox !== 'undefined' ? Fancybox : null);
        
        if (typeof FancyboxLib === 'undefined' || FancyboxLib === null) {
          console.error('Fancybox not available. Checking window object:', {
            Fancybox: typeof window.Fancybox,
            fancybox: typeof window.fancybox,
            global: typeof Fancybox
          });
          return;
        }
        
        console.log('Fancybox library found:', FancyboxLib);

        // Convert NodeList to Array
        const linksArray = Array.from(container._galleryLinks);
        
        if (linksArray.length === 0) {
          console.warn('No gallery links found');
          return;
        }

        // Unbind any existing Fancybox instances for these links
        try {
          if (typeof FancyboxLib.unbind === 'function') {
            FancyboxLib.unbind(linksArray);
          }
        } catch(e) {
          // Ignore if not bound
        }

        // Prepare gallery data for Fancybox
        const galleryData = linksArray.map(function(link) {
          const href = link.getAttribute('href');
          const caption = link.getAttribute('data-caption') || '';
          const img = link.querySelector('img');
          
          return {
            src: href,
            thumb: img ? img.src : href,
            //caption: caption
          };
        });

        // Bind Fancybox to gallery links
        try {
          // Ensure all links have proper data attributes
          linksArray.forEach(function(link, index) {
            const galleryName = container._galleryId || 'gallery';
            if (!link.hasAttribute('data-fancybox')) {
              link.setAttribute('data-fancybox', galleryName);
            }
            // Ensure href is set
            if (!link.getAttribute('href')) {
              const img = link.querySelector('img');
              if (img && img.src) {
                link.setAttribute('href', img.src);
              }
            }
          });

          // Options for Fancybox
          const options = {
            Toolbar: {
              display: {
                left: ['infobar'],
                middle: [],
                right: ['slideshow', 'download', 'close']
              }
            },
            Thumbs: {
              display: false,
              autoStart: false,
              showOnStart: false
            },
            Backdrop: {
              opacity: 0.8,
              close: true
            },
            Carousel: {
              Navigation: {
                prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>',
                nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>'
              }
            }
          };

          // Add click handlers to open Fancybox at the correct index
          linksArray.forEach(function(link, originalIndex) {
            // Store index as data attribute
            link.setAttribute('data-gallery-index', originalIndex);
            
            const clickHandler = function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              // Get the clicked index
              let clickedIndex = parseInt(this.getAttribute('data-gallery-index'), 10);
              
              // Fallback: find index by position in array
              if (isNaN(clickedIndex) || clickedIndex < 0) {
                clickedIndex = linksArray.indexOf(this);
              }
              
              // Ensure valid index
              if (clickedIndex < 0 || clickedIndex >= galleryData.length) {
                clickedIndex = 0;
              }
              
              // Open Fancybox with the clicked image as starting point
              try {
                // Create Fancybox instance with all options
                const fancyboxOptions = {
                  Toolbar: options.Toolbar,
                  Thumbs: options.Thumbs,
                  Backdrop: options.Backdrop,
                  Carousel: options.Carousel
                };
                
                let fancyboxInstance = null;
                
                // Create instance
                if (typeof FancyboxLib === 'function') {
                  fancyboxInstance = new FancyboxLib(galleryData, fancyboxOptions);
                } else if (typeof window.Fancybox === 'function') {
                  fancyboxInstance = new window.Fancybox(galleryData, fancyboxOptions);
                } else {
                  console.error('Fancybox constructor not available');
                  return false;
                }
                
                // Navigate to the clicked slide after a small delay to ensure instance is ready
                if (fancyboxInstance) {
                  setTimeout(function() {
                    // Try different methods to navigate to the clicked slide
                    if (fancyboxInstance.Carousel && typeof fancyboxInstance.Carousel.slideTo === 'function') {
                      fancyboxInstance.Carousel.slideTo(clickedIndex);
                    } else if (fancyboxInstance.carousel && typeof fancyboxInstance.carousel.slideTo === 'function') {
                      fancyboxInstance.carousel.slideTo(clickedIndex);
                    } else if (typeof fancyboxInstance.slideTo === 'function') {
                      fancyboxInstance.slideTo(clickedIndex);
                    } else if (typeof fancyboxInstance.jumpTo === 'function') {
                      fancyboxInstance.jumpTo(clickedIndex);
                    } else if (fancyboxInstance.plugins && fancyboxInstance.plugins.Carousel) {
                      fancyboxInstance.plugins.Carousel.slideTo(clickedIndex);
                    }
                  }, 50);
                }
              } catch(err) {
                console.error('Error opening Fancybox:', err);
              }
              
              return false;
            };
            
            // Remove any existing handlers and add new one
            link.removeEventListener('click', link._fancyboxClickHandler, true);
            link._fancyboxClickHandler = clickHandler;
            link.addEventListener('click', clickHandler, true);
          });

        } catch(e) {
          console.error('Error in Fancybox setup:', e);
          // Fallback: open manually on click
          linksArray.forEach(function(link, index) {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              const FancyboxConstructor = window.Fancybox || FancyboxLib;
              
              if (typeof FancyboxConstructor === 'function') {
                try {
                  // Get clicked index from the link
                  let clickedIndex = parseInt(link.getAttribute('data-gallery-index'), 10);
                  if (isNaN(clickedIndex) || clickedIndex < 0) {
                    clickedIndex = index;
                  }
                  
                  new FancyboxConstructor(galleryData, {
                    Toolbar: {
                      display: {
                        left: ['infobar'],
                        middle: [],
                        right: ['slideshow', 'download', 'close']
                      }
                    },
                    Thumbs: { 
                      display: false,
                      autoStart: false 
                    },
                    Backdrop: {
                      opacity: 0.8,
                      close: true
                    },
                    startIndex: clickedIndex >= 0 ? clickedIndex : 0
                  });
                } catch(err) {
                  console.error('Error creating Fancybox instance:', err);
                }
              }
            }, true);
          });
        }
      });
    });
  }

  function initArticleGallery() {
    // Small delay to ensure DOM is ready
    setTimeout(function() {
      initializeGalleries();
      
      // Retry Fancybox initialization after a longer delay if needed
      setTimeout(function() {
        const containers = document.querySelectorAll('.article-gallery__container');
        containers.forEach(function(container) {
          const links = container.querySelectorAll('.article-gallery__link');
          if (links.length > 0) {
            const FancyboxLib = window.Fancybox || window.fancybox || Fancybox;
            if (typeof FancyboxLib !== 'undefined' && typeof FancyboxLib.bind === 'function') {
              // Check if links are already bound
              const linksArray = Array.from(links);
              let needsBinding = false;
              linksArray.forEach(function(link) {
                if (!link.hasAttribute('data-fancybox-initialized')) {
                  needsBinding = true;
                }
              });
              
              if (needsBinding) {
                try {
                  FancyboxLib.bind(linksArray);
                  linksArray.forEach(function(link) {
                    link.setAttribute('data-fancybox-initialized', 'true');
                  });
                  console.log('Fancybox retry binding successful');
                } catch(e) {
                  console.error('Fancybox retry binding failed:', e);
                }
              }
            }
          }
        });
      }, 500);
    }, 100);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleGallery);
  } else {
    initArticleGallery();
  }

  // Re-initialize on Shopify section load
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initArticleGallery, 200);
  });
})();

